import type { BillingSectionData } from '#src/models/elation/visitNotes.ts'

/**
 * Elation Bill — from GET /bills?patient={id}
 *
 * Only fields consumed by the sync pipeline are typed here.
 * The full response has many more fields (providers, service_location, etc.)
 * that we don't need for billing section rendering.
 */
export interface Bill {
  id: number
  cpts: {
    dxs?: string[]
    cpt: string
    alt_dxs?: string[]
    modifiers?: string[]
    ndc?: string | null
    ndc_dose?: string | null
    ndc_measure?: string | null
    unit_charge?: string | null
    units?: number | null
  }[]
  billing_status: string
  billing_date: string | null
  ref_number: string | null
  service_date: string | null
  visit_note_id: number | null
  patient: number
}

/**
 * Convert an Elation Bill to the BillingSectionData format used by toFhir().
 */
export function toBillingSectionData(bill: Bill): BillingSectionData {
  return {
    bills: bill.cpts.map((cpt) => ({
      id: bill.id,
      dxs: cpt.dxs ?? [],
      cpt: cpt.cpt,
      modifiers: cpt.modifiers ?? [],
    })),
    billingStatus: bill.billing_status,
    billingDate: bill.billing_date ?? '',
    refNumber: bill.ref_number ?? '',
    serviceDate: bill.service_date ?? '',
  }
}
